import { Button as StyledButton, StyledWhatsAppButton } from './style.ts';
import WhatsappIcon from '../../assets/whatsapp-icon.svg';

interface BaseButtonProps {
  children: React.ReactNode;
  className?: string;
}

interface ButtonProps extends BaseButtonProps {
  onClick: () => void;
  type?: 'button' | 'submit' | 'reset';
}

interface WhatsAppButtonProps extends BaseButtonProps {
  href: string;
}

export const Button = ({ onClick, children, type = 'button', ...rest }: ButtonProps) => {
  return (
    <StyledButton type={type} onClick={onClick} {...rest}>
      {children}
    </StyledButton>
  );
};

export const WhatsAppButton = ({ href, children, ...rest }: WhatsAppButtonProps) => {
  return (
    <StyledWhatsAppButton href={href} target="_blank" rel="noopener noreferrer" {...rest}>
      {children}
      <img src={WhatsappIcon} alt="Ícone do whatsapp" />
    </StyledWhatsAppButton>
  );
};
